import React from 'react';

import CSSModules from 'react-css-modules';

import styles from './styles.module.scss';

type Props = {
  isCorrect: boolean;
  accessibilityLabels: {
    icon: {
      correct: string;
      incorrect: string;
    };
  };
};

const OrderingAnswerIconComponent = ({
  isCorrect,
  accessibilityLabels,
}: Props) => {
  const orderingIcons = {
    correct: (
      <svg
        width='38px'
        height='38px'
        viewBox='0 0 38 38'
        xmlns='http://www.w3.org/2000/svg'
        aria-label={accessibilityLabels.icon.correct}
      >
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <circle cx='19' cy='19' r='17.355192' />
          <path d='M15.522,21.502 L12.87,18.85 C12.4800729,18.4610643 11.8489271,18.4610643 11.459,18.85 L10.184,20.126 C9.79533658,20.5158786 9.7948896,21.1465709 10.183,21.537 L14.818,26.172 C15.2079271,26.5609357 15.8390729,26.5609357 16.229,26.172 L17.504,24.896 L17.538,24.861 L17.573,24.828 L27.58,14.82 C27.9690509,14.4297302 27.9690509,13.7982698 27.58,13.408 L26.305,12.133 C25.9147302,11.7439491 25.2832698,11.7439491 24.893,12.133 L15.523,21.503 L15.522,21.502 Z M19,38 C8.507,38 0,29.493 0,19 C0,8.507 8.507,0 19,0 C29.493,0 38,8.507 38,19 C38,29.493 29.493,38 19,38 Z' />
        </g>
      </svg>
    ),
    incorrect: (
      <svg
        width='38px'
        height='38px'
        viewBox='0 0 38 38'
        xmlns='http://www.w3.org/2000/svg'
        aria-label={accessibilityLabels.icon.incorrect}
      >
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <circle cx='19' cy='19' r='17.355192' />
          <path d='M19,0 C29.493,0 38,8.507 38,19 C38,29.493 29.493,38 19,38 C8.507,38 0,29.493 0,19 C0,8.507 8.507,0 19,0 Z M22.63,12.553 L22.535,12.637 L19,16.17 L15.465,12.636 C15.1064007,12.2782449 14.5370699,12.2447548 14.139,12.558 L14.044,12.642 L12.643,14.042 C12.4522756,14.2290412 12.3443154,14.4846167 12.3431793,14.7517476 C12.3420611,15.0188786 12.4478608,15.275356 12.637,15.464 L16.17,19 L12.636,22.535 C12.2782449,22.8935993 12.2447548,23.4629301 12.558,23.861 L12.642,23.956 L14.042,25.357 C14.3975138,25.7200329 14.9687556,25.7587466 15.37,25.447 L15.464,25.363 L19,21.83 L22.535,25.364 C22.898,25.727 23.466,25.751 23.861,25.442 L23.956,25.358 L25.357,23.958 C25.5477244,23.7709588 25.6556846,23.5153833 25.6568207,23.2482524 C25.6579389,22.9811214 25.5521392,22.724644 25.363,22.536 L21.83,19 L25.364,15.465 C25.727,15.102 25.751,14.534 25.442,14.139 L25.358,14.044 L23.958,12.643 C23.6024862,12.2799671 23.0312444,12.2412534 22.63,12.553 L22.63,12.553 Z' />
        </g>
      </svg>
    ),
  };

  const Icon = isCorrect ? orderingIcons.correct : orderingIcons.incorrect;

  return (
    <div styleName={`icon ${isCorrect ? 'correct' : 'incorrect'}`}>{Icon}</div>
  );
};

export const OrderingAnswerIcon = CSSModules(
  OrderingAnswerIconComponent,
  styles,
  {allowMultiple: true}
);
